<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="16">
        <BusinessInfoCard :clue_id="clue_id" @refreshData="refresh"/>
        <BusinessChangeLog :clue_id="clue_id" :refreshCount="refreshCount"/>
      </el-col>
      <el-col :span="8">
        <BusinessProgressPlan :clue_id="clue_id" @refreshData="refresh"/>
        <BusinessResultAnalyze :clue_id="clue_id" @refreshData="refresh"/>
        <BusinessPreSales :clue_id="clue_id" @refreshData="refresh"/>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import {
getclueInfo
} from '../../../api/api'
import BusinessChangeLog from "@/component/Business/detail/BusinessChangeLog";
import BusinessInfoCard from "@/component/Business/detail/BusinessInfoCard";
import BusinessProgressPlan from "@/component/Business/detail/BusinessProgressPlan";
import BusinessResultAnalyze from "@/component/Business/detail/BusinessResultAnalyze";
import BusinessPreSales from "@/component/Business/detail/BusinessPreSales";
export default {
  name: "BusinessDetail",
  props:["clue_id"],
  components:{
    BusinessChangeLog,
    BusinessInfoCard,
    BusinessProgressPlan,
    BusinessResultAnalyze,
    BusinessPreSales
  },
  data(){
    return {
      clueInfo:null,
      refreshCount:0
    }
  },
  async mounted() {

  },

  watch:{

  },

  methods:{
    async refresh(){
      this.refreshCount++
      this.$emit('refresh')
    }
  }
}
</script>
<style lang="scss">
.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height:200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  //background-color: rgb(188, 188, 188);
  background-color:#E4E7F2;
  border-radius: 4px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>

